import { AriaLabelingProps } from '../types/a11y-props.js';

/**
 * Utility function to extract aria-labeling props from component props to easily spread them to the desired child.
 * @internal
 */
export function useAriaLabelingProps<T extends object>(
  props: AriaLabelingProps & T,
): AriaLabelingProps {
  return {
    'aria-label': props['aria-label'],
    'aria-labelledby': props['aria-labelledby'],
    'aria-describedby': props['aria-describedby'],
    'aria-details': props['aria-details'],
  };
}
